import EmailChangeDialog from "./dialog/EmailChangeDialog";
import PasswordChangeDialog from "./dialog/PasswordChangeDialog";
import { Link } from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";
import useAppDispatch from "../../../../../../../hooks/redux/base/useAppDispatch";
import { openModal } from "../../../../../../../store/redux/slice/ComponentsControl/myAccountControl";
import styled from "styled-components";
import { GridContainer, GridItem, ViewSection } from "@duosoftbg/nacid-components";

const SpecialActionLink = styled(Link)`
  font-size: 15px;
  cursor: pointer;
`;

const SpecialActionsSection = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const handleOpenModal = (modalType) => {
    const payload = { modalType };
    dispatch(openModal(payload));
  };

  return (
    <>
      <EmailChangeDialog />
      <PasswordChangeDialog />
      <ViewSection label={"t.special.actions"}>
        <GridContainer spacing={5} mt={0}>
          <GridItem sm={12} md={12}>
            <SpecialActionLink variant="body2" onClick={() => handleOpenModal("emailChange")}>
              {t("l.btn.change.email")}
            </SpecialActionLink>
          </GridItem>
          <GridItem sm={12} md={12}>
            <SpecialActionLink variant="body2" onClick={() => handleOpenModal("passwordChange")}>
              {t("l.btn.change.password")}
            </SpecialActionLink>
          </GridItem>
        </GridContainer>
      </ViewSection>
    </>
  );
};

export default SpecialActionsSection;
